import { useState } from "react";

const useFileInputLogic = ({ inputRef, onChange }) => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");

  const handleChange = (e) => {
    const files = e?.target?.files?.[0];
    if (files?.size > 10000000) {
      window.setError(
        "file",
        {
          type: "validate",
          message: "File size should be less than 10MB",
        },
        { shouldFocus: true },
      );

      return;
    }

    setFile(files);
    setFileName(files?.name);
    onChange(files, files?.name);
  };

  const handleClick = () => inputRef.current.click();

  const handleClear = () => {
    setFile(null);
    setFileName("");
    onChange(null, "");
  };

  return {
    file,
    handleChange,
    fileName,
    handleClick,
    handleClear,
  };
};

export default useFileInputLogic;
